// Shared motion tokens (see /app/design_guidelines.json)
export const EASE = [0.16, 1, 0.3, 1];
export const EASE_HOVER = [0.25, 1, 0.5, 1];
